(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoae-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zoae-look')) {
    customElements.define('zoae-look', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        const close = (spot, focus) => { spot.open = false; if(focus) spot.querySelector('summary').focus(); };
        this.addEventListener('click', event => {
          const button = event.target.closest('.zoae-look__close');
          if(button) close(button.closest('details'),true);
        },options);
        this.addEventListener('keydown',event => {
          if(event.key === 'Escape') this.querySelectorAll('details[open]').forEach(spot => close(spot,true));
        },options);
        document.addEventListener('click',event => {
          if(!this.contains(event.target)) this.querySelectorAll('details[open]').forEach(spot => close(spot,false));
        },options);
        document.addEventListener('shopify:block:select',event => {
          const spot = event.target.closest('.zoae-look__spot');
          if(spot && this.contains(spot)) spot.open = true;
        },options);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoae-typing-headline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zoae-typing-headline')) {
    class ZoaeTypingHeadline extends HTMLElement {
      connectedCallback() {
        this.output = this.querySelector('.zoae-typing-headline__output');
        if (!this.output) return;

        this.originalText = this.dataset.text || this.output.textContent || '';
        this.runToken = (this.runToken || 0) + 1;
        this.hasPlayed = false;
        this.dataset.state = 'waiting';

        if (!this.originalText) return;

        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.output.textContent = this.originalText;
          this.dataset.state = 'complete';
          return;
        }

        this.output.textContent = '';

        if (this.dataset.startOnScroll !== 'true') {
          this.typeText();
          return;
        }

        if (!('IntersectionObserver' in window)) {
          this.output.textContent = this.originalText;
          this.dataset.state = 'complete';
          return;
        }

        const threshold = Math.max(0.1, Math.min(0.8, (Number(this.dataset.triggerThreshold) || 30) / 100));
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!this.hasPlayed || this.dataset.repeatOnScroll === 'true') {
                this.hasPlayed = true;
                this.typeText();
                if (this.dataset.repeatOnScroll !== 'true') this.observer.disconnect();
              }
            } else if (this.dataset.repeatOnScroll === 'true' && this.hasPlayed) {
              this.cancelAnimation(true);
              this.hasPlayed = false;
            }
          });
        }, { threshold });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.cancelAnimation(false);
        this.observer?.disconnect();
      }

      cancelAnimation(clearOutput) {
        this.runToken = (this.runToken || 0) + 1;
        if (clearOutput && this.output) {
          this.output.textContent = '';
          this.dataset.state = 'waiting';
        }
      }

      async typeText() {
        const run = ++this.runToken;
        const speed = Math.max(0, Number(this.dataset.typingSpeed) || 0);
        const wordPause = Math.max(0, Number(this.dataset.wordPause) || 0);
        const tokens = this.originalText.match(/\s+|\S+/g) || [];
        const wait = (duration) => new Promise((resolve) => window.setTimeout(resolve, duration));

        this.output.textContent = '';
        this.dataset.state = 'typing';

        for (let index = 0; index < tokens.length; index += 1) {
          if (run !== this.runToken || !this.isConnected) return;

          const token = tokens[index];

          if (/^\s+$/.test(token)) {
            this.output.textContent += token;
            continue;
          }

          if (this.dataset.animationStyle === 'word') {
            this.output.textContent += token;
          } else {
            for (const character of Array.from(token)) {
              if (run !== this.runToken || !this.isConnected) return;
              this.output.textContent += character;
              if (speed > 0) await wait(speed);
            }
          }

          const hasNextWord = tokens.slice(index + 1).some((next) => /\S/.test(next));
          if (hasNextWord && wordPause > 0) await wait(wordPause);
        }

        if (run === this.runToken && this.isConnected) this.dataset.state = 'complete';
      }
    }

    customElements.define('zoae-typing-headline', ZoaeTypingHeadline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoeder-featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zoeder-featured-collection')) {
    class ZoederFeaturedCollection extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.tabs = Array.from(this.querySelectorAll('.zoeder-collection-tabs [role="tab"]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(index), { signal: this.controller.signal });
          tab.addEventListener('keydown', (event) => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.selectTab(next);
            this.tabs[next].focus();
          }, { signal: this.controller.signal });
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
      selectTab(index) {
        this.tabs.forEach((tab, current) => {
          const selected = current === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel && this.contains(panel)) panel.hidden = !selected;
        });
        requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      }
    }
    customElements.define('zoeder-featured-collection', ZoederFeaturedCollection);
  }

  } catch(e) { console.error(e); }
})();
})();
